import React from "react";

export interface OverviewContent {
    title: string[];
    rows: string[][][];
}

interface Props {
    data: OverviewContent;
}
export const OverviewGrid: React.FC<Props> = ({ data }) => (
    <div className="w-full p-4 md:p-6 overflow-x-auto">
        <table className="min-w-full table-fixed border border-gray-300 text-sm md:text-base">
            <thead className="bg-gray-100">
                <tr>
                    {data.title.map((t, i) => (
                        <th key={i} className="border border-gray-300 px-2 py-2 md:px-4 md:py-2 text-left text-xs md:text-lg font-semibold w-1/4 break-words whitespace-pre-wrap">
                            {t}
                        </th>
                    ))}
                </tr>
            </thead>

            <tbody>
                {data.rows.map((row, rowIndex) => (
                    <tr key={rowIndex} className="even:bg-gray-50">
                        {row.map((cell, colIndex) => (
                            <td key={colIndex} className="border border-gray-300 px-2 py-2 md:px-4 md:py-2 align-top break-words whitespace-pre-wrap w-1/4">
                                {cell.map((text, i) => (
                                    <p key={i} className="text-xs md:text-base text-gray-700 pb-1">
                                        {cell.length > 1 ? `${i + 1}. ${text}` : text}
                                    </p>
                                ))}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);
